import { useSelector, useDispatch } from 'react-redux';
import { getCart, fetchCart, getIsInitial } from './index';
import { useLayoutEffect } from 'react';

export const useCartWithPrefetch = () => {
    const dispatch = useDispatch();
    const cart = useSelector(getCart);
    const isInitial = useSelector(getIsInitial);

    useLayoutEffect(() => {
        if (isInitial) {
            dispatch(fetchCart());
        }
    }, []);

    return cart;
};
